module.exports = __webpack_public_path__ + "img/5244537.png";